import script from "./ModuleView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleView.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleView.vue?vue&type=style&index=0&id=bc4eb146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc4eb146"]])

export default __exports__